import algoliasearch from "algoliasearch";

const client = algoliasearch(
    "T93EDZLA1V",
    "a8f7835dead6e31e662cc094833c8898"
);

export { client }